import { apiAxiosCMS } from 'services/api';
import { ItemScreenStatic } from 'types/ScreensStaticsProps';

export async function editStaticScreen(
	screen: ItemScreenStatic,
	handleNotify: any
) {
	const resp = await apiAxiosCMS
		.patch(`/static-pages/${screen?.id || '0'}`, { ...screen })
		.then(() => {
			handleNotify('Tela atualizada com sucesso!', 'success');
			return true;
		})
		.catch(() => {
			handleNotify(
				'Erro ao atualizar a tela estática. Tente novamente mais tarde.',
				'error'
			);
			return false;
		});

	return resp;
}
